import React, { useState } from "react";
import Modal from "react-modal";
import { trimTrailingSlash } from "../../../lib/utils";

export default function TeamCreatedModal({ onClose, slug }) {
  const teamUrl = `${window.location.origin}${trimTrailingSlash(
    window.location.pathname
  )}/${slug}`;

  const [copyingUrl, setCopyingUrl] = useState(false);
  const copyUrl = async () => {
    setCopyingUrl(true);
    await navigator.clipboard.writeText(teamUrl);
    setCopyingUrl(false);
  };

  return (
    <Modal
      isOpen={true}
      className="team-created-modal"
      portalClassName="team-created-modal-portal"
      // note that although this is a 'toast style' display we are using a modal and custom styling the overlay
      // because we have a ToastContainer mounted for donation notifications, and it seems (although the library officially supports it) that we can't use multiple ToastContainers
      onRequestClose={onClose}
    >
      <i className="material-icons team-created-close-button" onClick={onClose}>
        close
      </i>
      <p className="team-created-title">Your team has been created!</p>
      <p className="team-created-message">
        You can now share your page with your contacts and start selling
        tickets.
      </p>
      <a
        className="team-created-url"
        href={teamUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="material-icons">link</i>
        {teamUrl}
      </a>
      <button className="btn btn-text" onClick={copyUrl}>
        {copyingUrl ? "Copying" : "Copy"} link
      </button>
    </Modal>
  );
}
